"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DuplicateController", {
    enumerable: true,
    get: function() {
        return DuplicateController;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _globalguard = require("~/guards/global/global.guard");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _catchError = require("~/helpers/catchError");
const _exportImportHelpers = require("~/helpers/exportImportHelpers");
const _config = require("~/interface/config");
const _Jobs = require("~/interface/Jobs");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _models = require("~/models");
const _jobsserviceinterface = require("~/modules/jobs/jobs-service.interface");
const _duplicateservice = require("~/modules/jobs/jobs/export-import/duplicate.service");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _basesservice = require("~/services/bases.service");
const _duplicatemodelutils = require("~/utils/duplicate-model.utils");
const _globals = require("~/utils/globals");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let DuplicateController = class DuplicateController {
    async duplicateSharedBase(context, req, _workspaceId, sharedBaseId, body) {
        const base = await _models.Base.getByUuid({
            workspace_id: _globals.RootScopes.BASE,
            base_id: _globals.RootScopes.BASE
        }, sharedBaseId);
        if (!base) {
            _catchError.NcError.get(context).baseNotFound(sharedBaseId);
        }
        const source = (await base.getSources())[0];
        if (!source) {
            _catchError.NcError.get(context).noSourcesFound();
        }
        const bases = await _models.Base.list(context.workspace_id);
        const uniqueTitle = (0, _exportImportHelpers.generateUniqueName)(`${base.title} copy`, bases.map((p)=>p.title));
        const dupProject = await this.basesService.baseCreate({
            base: _extends({
                title: uniqueTitle,
                status: _nocodbsdk.ProjectStatus.JOB
            }, body.base || {}),
            user: {
                id: req.user.id
            },
            req
        });
        const job = await this.jobsService.add(_Jobs.JobTypes.DuplicateBase, {
            context: {
                workspace_id: base.fk_workspace_id,
                base_id: base.id
            },
            user: req.user,
            baseId: base.id,
            sourceId: source.id,
            dupProjectId: dupProject.id,
            dupWorkspaceId: dupProject.fk_workspace_id,
            options: _extends({}, body.options, {
                excludeHooks: true
            }),
            req
        });
        return {
            id: job.id,
            base_id: dupProject.id
        };
    }
    async duplicateBase(context, req, baseId, sourceId, body) {
        return await this.duplicateService.duplicateBase({
            context,
            req,
            baseId,
            sourceId,
            body
        });
    }
    async duplicateModel(context, req, baseId, modelId, body) {
        const { sourceBase, sourceModel, sourceSource, targetSource, uniqueTitle } = await _duplicatemodelutils.DuplicateModelUtils._.getDuplicateModelTaskInfo({
            baseId,
            body,
            context,
            modelId
        });
        const parentAuditId = await _Noco.default.ncAudit.genNanoid(_globals.MetaTable.AUDIT);
        this.appHooksService.emit(_nocodbsdk.AppEvents.TABLE_DUPLICATE_START, {
            sourceTable: sourceModel,
            user: req.user,
            req,
            context,
            id: parentAuditId,
            title: body == null ? void 0 : body.title,
            options: body == null ? void 0 : body.options
        });
        req.ncParentAuditId = parentAuditId;
        const job = await this.jobsService.add(_Jobs.JobTypes.DuplicateModel, {
            context,
            user: req.user,
            baseId: sourceBase.id,
            sourceId: sourceSource.id,
            targetSourceId: targetSource.id,
            modelId: sourceModel.id,
            title: uniqueTitle,
            options: body.options || {},
            req
        });
        return {
            id: job.id
        };
    }
    async duplicateColumn(context, req, baseId, columnId, body) {
        const base = await _models.Base.get(context, baseId);
        if (!base) {
            _catchError.NcError.get(context).baseNotFound(baseId);
        }
        const column = await _models.Column.get(context, {
            source_id: base.id,
            colId: columnId
        });
        if (!column) {
            _catchError.NcError.get(context).fieldNotFound(columnId);
        }
        const model = await _models.Model.get(context, column.fk_model_id);
        if (!model) {
            _catchError.NcError.get(context).tableNotFound(column == null ? void 0 : column.fk_model_id);
        }
        const parentAuditId = await _Noco.default.ncAudit.genNanoid(_globals.MetaTable.AUDIT);
        this.appHooksService.emit(_nocodbsdk.AppEvents.COLUMN_DUPLICATE_START, {
            table: model,
            sourceColumn: column,
            user: req.user,
            req,
            context,
            id: parentAuditId,
            options: body == null ? void 0 : body.options
        });
        req.ncParentAuditId = parentAuditId;
        const source = await _models.Source.get(context, model.source_id);
        // check if source is readonly and column type is not allowed
        if (!_nocodbsdk.readonlyMetaAllowedTypes.includes(column.uidt)) {
            if (source.is_schema_readonly) {
                _catchError.NcError.get(context).sourceMetaReadOnly(source.alias);
            }
            if (source.is_data_readonly) {
                _catchError.NcError.get(context).sourceDataReadOnly(source.alias);
            }
        }
        req.ncParentAuditId = parentAuditId;
        req.ncBaseId = baseId;
        req.ncSourceId = source.id;
        const job = await this.jobsService.add(_Jobs.JobTypes.DuplicateColumn, {
            context,
            user: req.user,
            baseId: base.id,
            sourceId: column.source_id,
            modelId: model.id,
            columnId: column.id,
            options: body.options || {},
            extra: body.extra || {},
            req
        });
        return {
            id: job.id
        };
    }
    constructor(jobsService, basesService, appHooksService, duplicateService){
        this.jobsService = jobsService;
        this.basesService = basesService;
        this.appHooksService = appHooksService;
        this.duplicateService = duplicateService;
    }
};
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/duplicate/:workspaceId/shared/:sharedBaseId',
        '/api/v2/meta/duplicate/:workspaceId/shared/:sharedBaseId'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('duplicateSharedBase', {
        scope: 'org'
    }),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('workspaceId')),
    _ts_param(3, (0, _common.Param)('sharedBaseId')),
    _ts_param(4, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], DuplicateController.prototype, "duplicateSharedBase", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/duplicate/:baseId/:sourceId?',
        '/api/v2/meta/duplicate/:baseId/:sourceId?'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('duplicateBase'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('baseId')),
    _ts_param(3, (0, _common.Param)('sourceId')),
    _ts_param(4, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], DuplicateController.prototype, "duplicateBase", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/duplicate/:baseId/table/:modelId',
        '/api/v2/meta/duplicate/:baseId/table/:modelId'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('duplicateModel'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('baseId')),
    _ts_param(3, (0, _common.Param)('modelId')),
    _ts_param(4, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], DuplicateController.prototype, "duplicateModel", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/duplicate/:baseId/column/:columnId',
        '/api/v2/meta/duplicate/:baseId/column/:columnId'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('duplicateColumn'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('baseId')),
    _ts_param(3, (0, _common.Param)('columnId')),
    _ts_param(4, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], DuplicateController.prototype, "duplicateColumn", null);
DuplicateController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_param(0, (0, _common.Inject)('JobsService')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _jobsserviceinterface.IJobsService === "undefined" ? Object : _jobsserviceinterface.IJobsService,
        typeof _basesservice.BasesService === "undefined" ? Object : _basesservice.BasesService,
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService,
        typeof _duplicateservice.DuplicateService === "undefined" ? Object : _duplicateservice.DuplicateService
    ])
], DuplicateController);
